function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function webpackUniversalModuleDefinition(root, factory) {
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && (typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object') module.exports = factory(require("jquery"), require("xo"), require("xo-cookie"));else if (typeof define === 'function' && define.amd) define(["jquery", "xo", "xo-cookie"], factory);else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') exports["membership"] = factory(require("jquery"), require("xo"), require("xo-cookie"));else root["XO"] = root["XO"] || {}, root["XO"]["membership"] = factory(root["jQuery"], root["XO"], root["XO"]["cookie"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__) {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/
      var installedModules = {};

      /******/ // The require function
      /******/
      function __webpack_require__(moduleId) {
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;

        /******/ // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
          /******/exports: {},
          /******/id: moduleId,
          /******/loaded: false
          /******/
        };

        /******/ // Execute the module function
        /******/
        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

        /******/ // Flag the module as loaded
        /******/
        module.loaded = true;

        /******/ // Return the exports of the module
        /******/
        return module.exports;
        /******/
      }

      /******/ // expose the modules object (__webpack_modules__)
      /******/
      __webpack_require__.m = modules;

      /******/ // expose the module cache
      /******/
      __webpack_require__.c = installedModules;

      /******/ // __webpack_public_path__
      /******/
      __webpack_require__.p = "";

      /******/ // Load entry module and return exports
      /******/
      return __webpack_require__(0);
      /******/
    }
    /************************************************************************/
    /******/([/* 0 */
    /***/function (module, exports, __webpack_require__) {
      'use strict';

      var membership = __webpack_require__(1);
      var $ = __webpack_require__(2);

      /* extend with deprecated interfaces */
      membership.get_member = deprecatedGetMember;
      membership.create_member = deprecatedCreateMember;
      membership.update_member = deprecatedUpdateMember;
      membership.is_logged_in = deprecatedIsLoggedIn;
      module.exports = membership;

      /**
      * Synchronously get current member.
      *
      * @deprecated Use {@link XO.membership.App#getMember}
      * @function get_member
      * @memberof XO.membership
      */
      function deprecatedGetMember() {
        var returnValue;
        deprecated('XO.membership.get_member is deprecated because it makes ' + 'synchrounous calls. Please use XO.membership.App#getMember');
        membership.defaultInstance.getMemberSync().done(function (member) {
          returnValue = member;
        });
        return returnValue || {};
      }

      /**
      * Synchronously check if member is logged in
      *
      * @deprecated This is going away entirely, use {@link XO.membership.App#getMember}
      *   Which should suffice for testing the user's logged in status.
      * @function is_logged_in
      * @memberof XO.membership
      */
      function deprecatedIsLoggedIn() {
        deprecated('XO.membership.is_logged_in is deprecated. Please ' + 'use XO.membership.App#getMember');
        return !!deprecatedGetMember().id;
      }

      /**
      * Create a member
      *
      * @deprecated Use {@link XO.membership.App#createMember}
      * @function create_member
      * @memberof XO.membership
      */
      function deprecatedCreateMember(memberData, success, fail) {
        deprecated('XO.membership.create_member is deprecated. Please ' + 'use XO.membership.App#createMember');
        membership.defaultInstance.createMember(memberData).done(success).fail(function backwardsCompatibleFailCallback(ignoredErrors, jqHXR) {
          if (typeof fail === 'function') {
            fail(jqXHR);
          }
        });
      }

      /**
      * Update a member
      *
      * @deprecated Use {@link XO.membership.App#updateMember}
      * @function update_member
      * @memberof XO.membership
      */
      function deprecatedUpdateMember(memberData, success, fail) {
        deprecated('XO.membership.update_member is deprecated. Please ' + 'use XO.membership.App#updateMember');
        membership.defaultInstance.updateMember(memberData).done(success).fail(function backwardsCompatibleFailCallback(ignoredErrors, jqHXR) {
          if (typeof fail === 'function') {
            fail(jqXHR);
          }
        });
      }
      function deprecated(message) {
        console.warn('DEPRECATED: ' + message);
      }

      /*
       * This needs to live until the old membership UI modals are completely
       * retired
       * */
      $('body').on('authenticated', function () {
        membership.defaultInstance.clearCache();
      });

      /***/
    }, /* 1 */
    /***/function (module, exports, __webpack_require__) {
      'use strict';

      var jQuery = __webpack_require__(2);
      var App = __webpack_require__(3);
      var Metadata = __webpack_require__(9);

      /**
      * SDK entrypoint.
      *
      * @method
      * @memberof XO.membership
      *
      * @see XO.membership.App
      *
      * @param {object} options - App options
      * @param {object} options.application - Translated into .name before passed
      *   to App instance
      *
      * @return {XO.membership.App}
      */
      exports.init = function init(options) {
        /* Copying object to not modify passed object */
        options = jQuery.extend({}, options);

        /* Translate options for App instance */
        options.name = options.application;
        delete options.application;
        return new App(options);
      };
      exports.defaultInstance = exports.init({
        apiKey: function () {
          // default to a QA API key
          var apiKey = 'AoSWj4Qf6sBwWznSH94eUzx6p6Ne5Lin';
          var env = Metadata.environment();
          if (env === 'production' || env === 'prod') {
            apiKey = 'wnEZ6ar2Wp9pWWATDcacqaLIKHsuUcDi';
          }
          return apiKey;
        }(),
        useMetadataForHost: true
      });
      module.exports.version = "4.0.2";

      /***/
    }, /* 2 */
    /***/function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

      /***/
    }, /* 3 */
    /***/function (module, exports, __webpack_require__) {
      'use strict';

      var XO = __webpack_require__(4);
      var $ = __webpack_require__(2);
      var Cookies = __webpack_require__(5);
      var Client = __webpack_require__(7);
      var Metadata = __webpack_require__(9);
      module.exports = function () {
        var memberPromiseCache = null;
        /**
         * Used to support deprecated synchronous interfaces
         */
        var memberSyncPromiseCache = null;

        /**
        * An App uses a {@link XO.membership.Client} instance to interact with the
        * membership API. It uses {@link XO.membership.Cookies} to maintain browser
        * state.
        *
        * All client methods return a {@link http://api.jquery.com/Types/#Promise|jQuery~Promise}.
        *
        * @requires XO.metadata
        * @requires jQuery
        *
        * @constructor
        * @memberof XO.membership
        * @param {object} options Some are passed to {@link XO.membership.Client}
        * @param {string=} options.name Application name, if not passed, it will be
        *   determine based on the application.name in XO.metadata
        *
        * @example
        *   var app, appConfigurations;
        *
        *   appConfigurations = {
        *     name: 'marketplace',
        *
        *     // Options parsed by Client
        *     apiKey: 'my-api-key',
        *
        *     // Options parsed by Router
        *     useMetadataForHost: true
        *     // environment: 'qa',
        *     // host: 'http://custom-url-for-api'
        *   };
        *
        *   app = new XO.membership.App(appConfigurations);
        */
        function App(options) {
          var appName;
          options = options || {};
          appName = options.name || Metadata.applicationName();
          this.client = new Client(options);
          this.assumedMemberAttributes = {
            application: appName,
            brand: 'theknot'
          };
        }
        App.prototype.getMemberSync = getMemberSync;
        App.prototype.getMember = getMember;
        App.prototype.createMember = createMember;
        App.prototype.updateMember = updateMember;
        App.prototype.authenticate = authenticate;
        App.prototype.logOut = logOut;
        App.prototype.clearCache = function clearCache() {
          memberPromiseCache = null;
          memberSyncPromiseCache = null;
        };

        /**
        * NOT RECOMMENDED: Get a member synchronously.
        *
        * It only makes the request if there is not a cached promise. Methods that
        * cache promises include:
        *
        *   * {@link XO.membership.App#getMember}
        *   * {@link XO.membership.App#createMember}
        *
        * @instance
        * @method
        * @memberof XO.membership.App
        *
        * @return {jQuery~Promise}
        */
        function getMemberSync() {
          var token;
          if (!memberSyncPromiseCache) {
            token = Cookies.sessionToken();
            memberSyncPromiseCache = this.client.getMemberSync({
              sessionToken: token
            });
          }
          return memberSyncPromiseCache;
        }

        /**
        * Get a member
        *
        * It only makes the request if there is not a cached promise. Methods that
        * cache promises include:
        *
        *   * {@link XO.membership.App#getMember}
        *   * {@link XO.membership.App#createMember}
        *
        * @instance
        * @method
        * @memberof XO.membership.App
        *
        * @return {jQuery~Promise}
        */
        function getMember() {
          var token;
          if (!memberPromiseCache) {
            token = Cookies.sessionToken();
            memberPromiseCache = this.client.getMember({
              sessionToken: token
            });
          }
          return memberPromiseCache;
        }

        /**
        * Crate a member. See {@link XO.membership.Client.createMember}
        *
        * If successful, it:
        *
        *   * Caches the request. See {@link XO.membership.Cache#store}
        *   * Logs the member in (set necessary cookies). See {@link XO.membership.Cookies.logMemberIn}
        *   * Reports to analytics. See [XO.membership.Analytics]{@link https://git.xogrp.com/Membership/xo.membership.analytics}.reportNewRegistration
        *
        * @instance
        * @method
        * @param {object} memberData data for create
        * @param {object} options Additional options
        * @param {string} options.reason Reason to report to analytics. Also used as the member's action
        *
        * @memberof XO.membership.App
        *
        * @return {jQuery~Promise}
        */
        function createMember(memberData, options) {
          var promise, completeMemberData;
          if (options === undefined) {
            options = {};
          }
          completeMemberData = $.extend({
            action: options.reason
          }, memberData, this.assumedMemberAttributes);
          promise = this.client.createMember({
            data: completeMemberData
          });
          promise.done(logMemberInCallback, function reportNewRegistrationCallback(member) {
            XO.membership.Analytics.reportNewRegistration(member, options);
          }, notifyAuthentication, function cacheRequestCallback(member, _, promise) {
            memberPromiseCache = promise;
          });
          return promise;
        }

        /**
        * Crate a session. See {@link XO.membership.Client.createMember}
        *
        * If successful, it:
        *
        *   * Logs the member in (set necessary cookies). See {@link XO.membership.Cookies.logMemberIn}
        *   * Reports 'Log in' event to analytics
        *
        * @instance
        * @method
        * @param {object} memberData data for authenticate
        * @param {object} options Additional options
        * @param {string} options.reason Reason to report to analytics.
        *
        * @memberof XO.membership.App
        *
        * @return {jQuery~Promise}
        */
        function authenticate(memberData, options) {
          var promise,
            completeMemberData,
            self = this;
          if (options === undefined) {
            options = {};
          }
          completeMemberData = $.extend({}, memberData, this.assumedMemberAttributes);
          promise = this.client.authenticateMember({
            data: completeMemberData
          });
          promise.done(logMemberInCallback, function (member) {
            XO.membership.Analytics.reportLogIn(member, options);
          }, notifyAuthentication, function () {
            self.clearCache();
          });
          return promise;
        }

        /**
         * Destroy a session and clear cookies
         * @return {jQuery~Promise}
         */
        function logOut() {
          var d = $.Deferred();
          var promise;
          var sessionToken = Cookies.sessionToken();
          promise = this.client.destroyMemberSession({
            sessionToken: sessionToken
          });
          promise.always(function (r) {
            Cookies.logMemberOut();
            if (typeof mixpanel !== 'undefined') {
              mixpanel.reset();
            }
            d.resolve(r);
          });
          return d.promise();
        }

        /**
        * Update member. See {@link XO.membership.Client#updateMember}
        * If successful, it:
        *   - Clears the request cache for the logged in member. See
        *   {@link XO.membership.Cache#clear}
        *
        * @instance
        * @method
        * @memberof XO.membership.App
        * @param {object} memberData data for update
        *
        * @return {jQuery~Promise}
        */
        function updateMember(memberData) {
          var promise;
          function updateCache() {
            memberPromiseCache = promise;
          }
          promise = this.client.updateMember({
            data: memberData,
            sessionToken: Cookies.sessionToken()
          });
          promise.done(updateCache);
          return promise;
        }
        function logMemberInCallback(member) {
          Cookies.logMemberIn(member.latestSession());
        }
        function notifyAuthentication(member) {
          $(document.body).trigger('authenticated', {
            member: member
          });
        }
        return App;
      }();

      /***/
    }, /* 4 */
    /***/function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

      /***/
    }, /* 5 */
    /***/function (module, exports, __webpack_require__) {
      (function webpackUniversalModuleDefinition(root, factory) {
        if (true) module.exports = factory(__webpack_require__(6));else if (typeof define === 'function' && define.amd) define(["xo-cookie"], factory);else if (_typeof(exports) === 'object') exports["MembershipCookies"] = factory(require("xo-cookie"));else root["XO"] = root["XO"] || {}, root["XO"]["MembershipCookies"] = factory(root["XO"]["cookie"]);
      })(this, function (__WEBPACK_EXTERNAL_MODULE_1__) {
        return (/******/function (modules) {
            // webpackBootstrap
            /******/ // The module cache
            /******/
            var installedModules = {};

            /******/ // The require function
            /******/
            function __webpack_require__(moduleId) {
              /******/ // Check if module is in cache
              /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;

              /******/ // Create a new module (and put it into the cache)
              /******/
              var module = installedModules[moduleId] = {
                /******/exports: {},
                /******/id: moduleId,
                /******/loaded: false
                /******/
              };

              /******/ // Execute the module function
              /******/
              modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

              /******/ // Flag the module as loaded
              /******/
              module.loaded = true;

              /******/ // Return the exports of the module
              /******/
              return module.exports;
              /******/
            }

            /******/ // expose the modules object (__webpack_modules__)
            /******/
            __webpack_require__.m = modules;

            /******/ // expose the module cache
            /******/
            __webpack_require__.c = installedModules;

            /******/ // __webpack_public_path__
            /******/
            __webpack_require__.p = "";

            /******/ // Load entry module and return exports
            /******/
            return __webpack_require__(0);
            /******/
          }
          /************************************************************************/
          /******/([/* 0 */
          /***/function (module, exports, __webpack_require__) {
            'use strict';

            var cookie = __webpack_require__(1);
            /**
            * Membership related cookie management
            *
            * @namespace Cookies
            * @requires xo-cookie
            */
            exports.VERSION = "1.0.0";

            /**
            * Get the session token of logged in member
            *
            * @return {string}
            */
            exports.sessionToken = function sessionToken() {
              return cookie.getCookie('xo-session-token');
            };

            /**
            * Start a browser session for a user
            *
            * @param {object} apiSession Session object returned by API
            * @param {string} apiSession.token
            */
            exports.logMemberIn = function logMemberIn(apiSession) {
              var token = apiSession.token;
              setCookie('xo-session-token', token);
              setCookie('xo_acct_exists', 'true', 365);
            };

            /**
            * End a browser session for a user
            *
            * @function
            * @memberof XO.membership.Cookies
            */
            exports.logMemberOut = function logMemberOut() {
              deleteCookie('xo-session-token');
              deleteCookie('TMPAUTHTIX');
              deleteCookie('STATICAUTHTIX');
            };
            function setCookie(key, value, expires) {
              expires = expires || 30;
              cookie.setCookie(key, value, expires, '/', '.theknot.com');
            }
            function deleteCookie(key) {
              cookie.deleteCookie(key, '/', '.theknot.com');
            }

            /***/
          }, /* 1 */
          /***/function (module, exports) {
            module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

            /***/
          }
          /******/])
        );
      });

      ;

      /***/
    }, /* 6 */
    /***/function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

      /***/
    }, /* 7 */
    /***/function (module, exports, __webpack_require__) {
      'use strict';

      var jQuery = __webpack_require__(2);
      var Router = __webpack_require__(8);
      var Member = __webpack_require__(10);
      module.exports = function () {
        /**
        * Wrapper for api interactions. See
        * {@link http://docs.membershipapi1.apiary.io/#reference/members|Api Documentation}.
        * All client methods return a {@link http://api.jquery.com/Types/#Promise|jQuery~Promise}.
        *
        * @constructor
        * @memberof XO.membership
        * @requires jQuery
        *
        * @param {object} options - Client options. Some are passed to
        *   {@link XO.membership.Router}.
        * @param {string} options.apiKey - Application api key.
        *
        * @throws {XO.membership.Client~ConfigurationError} When apiKey option is
        *  missing.
        * @see XO.membership.Router
        *
        * @example
        *  var qaClient, prodClient, customClient;
        *
        *  qaClient = new XO.membership.Client({
        *    apiKey: 'abc123', environment: 'qa'});
        *
        *  prodClient = new XO.membership.Client({
        *    apiKey: 'abc123', environment: 'production'});
        *
        *  customClient = new XO.membership.Client({
        *    apiKey: 'abc123', host: 'http://localhost:5000'});
        */
        function Client(options) {
          options = options || {};
          this.router = new Router(options);
          if (options.apiKey) {
            this.apiKey = options.apiKey;
          } else {
            throw new ConfigurationError('missing api key');
          }
        }
        Client.prototype.createMember = createMember;
        Client.prototype.getMember = getMember;
        Client.prototype.getMemberSync = getMemberSync;
        Client.prototype.updateMember = updateMember;
        Client.prototype.authenticateMember = authenticateMember;
        Client.prototype.destroyMemberSession = destroyMemberSession;
        /**
        * Attempt to update a member. See
        * {@link http://docs.membershipapi1.apiary.io/#reference/members/members-collection/update-a-member|Api Documentation for more details}
        *
        * @instance
        * @memberof XO.membership.Client
        *
        * @param {object} requestOptions
        * @param {object} requestOptions.data - Member data.
        * @param {string} requestOptions.sessionToken
        *
        * @return {jQuery~Promise}
        */
        function updateMember(requestOptions) {
          var configs;
          configs = requestConfigs(this, {
            type: 'PATCH',
            data: {
              members: requestOptions.data
            }
          });
          return makeRequestWithSessionToken(requestOptions.sessionToken, configs);
        }

        /**
        * Get a member. See
        * {@link http://docs.membershipapi1.apiary.io/#reference/members/members-collection/get-a-member|Api Documentation for more details}
         *
        * @instance
        * @method
        * @memberof XO.membership.Client
        *
        * @param {object} requestOptions
        * @param {string} requestOptions.sessionToken
        *
        * @return {jQuery~Promise}
        */
        function getMember(requestOptions) {
          var configs;
          configs = requestConfigs(this, {
            type: 'GET'
          });
          return makeRequestWithSessionToken(requestOptions.sessionToken, configs);
        }

        /**
        * (NOT RECOMMENDED) Synchronously get a member. See
        * {@link http://docs.membershipapi1.apiary.io/#reference/members/members-collection/get-a-member|Api Documentation for more details}.
        *
        * @instance
        * @method
        * @memberof XO.membership.Client
        *
        * @param {object} requestOptions
        * @param {string} requestOptions.sessionToken
        *
        * @return {jQuery~Promise}
        */
        function getMemberSync(requestOptions) {
          var configs;
          configs = requestConfigs(this, {
            type: 'GET',
            async: false
          });
          return makeRequestWithSessionToken(requestOptions.sessionToken, configs);
        }

        /**
        * Attempt to create a member. See
        * {@link http://docs.membershipapi1.apiary.io/#reference/members/members-collection/create-a-member|Api Documentation for more details}
        *
        * @instance
        * @method
        * @memberof XO.membership.Client
        *
        * @param {object} requestOptions
        * @param {object} requestOptions.data - Member data.
        *
        * @return {jQuery~Promise}
        * @example
        *   client.createMember({
        *     data: {
        *       email: 'my_unique_email@email.com',
        *       password: 'abc123'
        *       ...
        *     }
        *   });
        */
        function createMember(requestOptions) {
          var configs;
          configs = requestConfigs(this, {
            type: 'POST',
            data: {
              members: requestOptions.data
            }
          });
          if (XO.queryString && XO.queryString.membership_api_debug_token) {
            configs.headers = {
              'X-Membership-Debug-Token': XO.queryString.membership_api_debug_token
            };
          }
          return makeRequest(configs);
        }
        /**
        * Attempt to authenticate a member. See
        * {@link http://docs.membershipapi1.apiary.io/#reference/sessions/session/create-session}
        *
        * @instance
        * @memberof XO.membership.Client
        *
        * @param {object} requestOptions
        * @param {object} requestOptions.data - Authentication data: email and password.
        *
        * @return {jQuery~Promise}
        */
        function authenticateMember(requestOptions) {
          var configs;
          configs = requestConfigs(this, {
            type: 'POST',
            data: {
              sessions: requestOptions.data
            },
            url: this.router.sessionsUrl({
              apikey: this.apiKey
            })
          });
          return makeRequest(configs);
        }

        /**
        * Attempt to log out a member. See
        *
        * @instance
        * @memberof XO.membership.Client
        *
        * @param {object} requestOptions
        * @param {string} requestOptions.sessionToken
        *
        * @return {jQuery~Promise}
        */
        function destroyMemberSession(requestOptions) {
          var configs;
          configs = requestConfigs(this, {
            type: 'DELETE',
            url: this.router.sessionsUrl({
              apikey: this.apiKey
            })
          });
          return makeRequestWithSessionToken(requestOptions.sessionToken, configs);
        }

        /**
        * Generate request configurations for jQuery.ajax. It maintains a list of
        * default options internally.
        *
        * @inner
        * @function
        * @memberof XO.membership.Client
        *
        * @param {XO.membership.Client} - client instance
        * @param {Object} variantConfig - Overides. This allows each individual
        *  request method to provide the least minimum of information to
        *  accomplish their request.
        * @return {Object} An object containing configurations ready to be passed.
        *  to jQuery.ajax.
        */
        function requestConfigs(client, variantConfigs) {
          var defaults, completeConfigs;
          defaults = {
            crossDomain: true,
            xhrFields: {
              withCredentials: true
            },
            contentType: 'application/json',
            url: client.router.membersUrl({
              apikey: client.apiKey
            })
          };

          // a recursive merge between the defaults and variants
          completeConfigs = jQuery.extend(true, defaults, variantConfigs);

          // stringify payload since this is an application/json request
          completeConfigs.data = JSON.stringify(completeConfigs.data);
          return completeConfigs;
        }

        /**
        * Filter out get and update requests with no session token
        * Use for requests that require membership token
        *
        * @inner
        * @function
        * @memberof XO.membership.Client
        * @param configs Ajax configuration object
        *
        * @return {jQuery~Promise}
        */
        function makeRequestWithSessionToken(sessionToken, configs) {
          var deferred = jQuery.Deferred();
          var promiseToReturn = deferred.promise();
          var errorMessage = [{
            title: 'unauthorized',
            detail: 'Invalid session token.'
          }];

          // Default promise is always rejected
          deferred.reject(errorMessage);
          if (sessionToken) {
            configs.headers = {
              'MEMBERSHIP-SESSION-TOKEN': sessionToken
            };
            promiseToReturn = makeRequest(configs);
          }
          return promiseToReturn;
        }

        /**
        * Make request and add a filter to parse the response as a Member object
        *
        * @inner
        * @function
        * @memberof XO.membership.Client
        * @param configs Ajax configuration object
        *
        * @return {jQuery~Promise}
        */
        function makeRequest(configs) {
          var jqXHR, deferred;
          function successFilter(apiResponse) {
            var parseResponse = apiResponse == null ? null : new Member(apiResponse);
            deferred.resolve(parseResponse, jqXHR);
          }
          function failFilter(apiResponse) {
            var errors, defaultError;
            defaultError = [{
              title: 'service_unavailable',
              detail: 'Unable to reach membership service. Try again later.'
            }];

            /*
             * The diferred object is here solely to filter the response.
             * This was originally accomplished by using the
             * [jQuery.Deferred#then](https://api.jquery.com/deferred.then/)
             * method. However, #then does not allow the filtering of multiple
             * parameters as it is done in the failure filter. The reason why the failure
             * filter needs to pass multiple parameters to the handlers is because
             * we need access to the jqXHR object in XO.membership.create_member,
             * get_member, and update_member, for backwards compatibility, while
             * supporting a sensible abstraction (just give me the errors) for version
             * 3.0.0 and greater of this library. Therefore, we are creating our own
             * deferred object that is _resolved_ when the request is successful, and
             * _rejected_ when it is not; both Deferred#resolve and Deferred#reject
             * allow you to controll all of the parameters passed to the callbacks.
             *
             * For consistency, it might make sense to provide the jqXHR object on both
             * success and failure.
             */
            errors = errorsFromResponse(apiResponse) || defaultError;
            deferred.reject(errors, jqXHR);
          }
          deferred = jQuery.Deferred();
          if (configs.async === false) {
            delete configs.xhrFields;
            configs.success = successFilter;
          }
          jqXHR = jQuery.ajax(configs);
          jqXHR.done(successFilter);
          jqXHR.fail(failFilter);
          return deferred.promise();
        }
        function errorsFromResponse(response) {
          return response && response.responseJSON && response.responseJSON.errors;
        }

        /**
        * @inner
        * @constructor
        * @memberof XO.membership.Client
        */
        function ConfigurationError(msg) {
          this.name = 'ConfigurationError';
          this.message = msg || '';
        }
        ConfigurationError.prototype = Error.prototype;
        return Client;
      }();

      /***/
    }, /* 8 */
    /***/function (module, exports, __webpack_require__) {
      'use strict';

      var XO = __webpack_require__(4);
      var $ = __webpack_require__(2);
      var Metadata = __webpack_require__(9);
      module.exports = function () {
        var QA_HOST, PROD_HOST;
        PROD_HOST = 'https://membership-api.theknot.com';
        QA_HOST = 'https://qa-membership-api.theknot.com';

        /**
        * Path resolutions based on the environment or an explicitly provided
        * url
        *
        * @requires XO.metadata
        * @requires TkplUtils
        *
        * @constructor
        * @memberof XO.membership
        * @param {object} options - Router options
        * @param {string=} options.environment - App environment, used
        *  to determine the host unless host is explicitly specified.
        *  'production' or 'qa'.
        * @param {boolean=} options.useMetadataForHost - Use XO.metadata to determine
        *   environment
        * @param {string} options.host - Api host. This option takes presedence over
        *  the -environment- option.
        */
        function Router(options) {
          options = options || {};
          this.host = options.host || determineHost(options);
        }
        Router.prototype.membersUrl = membersUrl;
        Router.prototype.sessionsUrl = sessionsUrl;

        /**
        * @method
        * @memberof XO.membership.Router
        * @param {object=} queryParams query parameters to append
        * @return {string} The url to interact wihth member data
        */
        function membersUrl(queryParams) {
          var url;
          url = this.host + '/members' + getQueryStringParams(queryParams);
          return url;
        }

        /**
        * @method
        * @memberof XO.membership.Router
        * @param {object=} queryParams query parameters to append
        * @return {string} The url to interact with sessions data
        */
        function sessionsUrl(queryParams) {
          var url;
          url = this.host + '/sessions' + getQueryStringParams(queryParams);
          return url;
        }

        /**
        * @method
        * @memberof XO.membership.Router
        * @param {object=} queryParams parameters to append
        * @return {string} The queryString parameters to append
        */
        function getQueryStringParams(queryParams) {
          var queryString;
          if (queryParams && Object.keys(queryParams).length > 0) {
            queryString = $.param(queryParams);
            return '?' + queryString;
          }
          return '';
        }
        function determineHost(options) {
          var environment;
          if (options.useMetadataForHost) {
            environment = Metadata.environment();
          } else {
            environment = options.environment;
          }
          return hostForEnvironment(environment || 'qa');
        }
        function hostForEnvironment(environment) {
          if (environment === 'prod' || environment === 'production') {
            return PROD_HOST;
          } else {
            return QA_HOST;
          }
        }
        return Router;
      }();

      /***/
    }, /* 9 */
    /***/function (module, exports, __webpack_require__) {
      'use strict';

      var XO = __webpack_require__(4);
      module.exports = {
        applicationName: function applicationName() {
          return XO && XO.metadata && XO.metadata.application && XO.metadata.application.name;
        },
        environment: function environment() {
          return XO && XO.metadata && XO.metadata.application && XO.metadata.application.deployment_environment;
        }
      };

      /***/
    }, /* 10 */
    /***/function (module, exports, __webpack_require__) {
      'use strict';

      var $ = __webpack_require__(2);
      module.exports = function () {
        /**
        * Api member wrapper
        *
        * @requires TKPL.util
        *
        * @constructor
        * @memberof XO.membership
        * @param {object} apiResonse Response as it comes from the member's endpoints
        */
        function Member(apiResponse) {
          var members = apiResponse.members || linked(apiResponse, 'members');
          var sessions = linked(apiResponse, 'sessions') || [apiResponse.sessions];
          $.extend(this, members);
          this.addresses = linked(apiResponse, 'addresses');
          this.sessions = sessions;
        }
        Member.prototype.latestSession = latestSession;

        /**
        * The latest session started. This is usually the session created for the
        * user when he creates an account or logs in.
        *
        * @instance
        * @method
        * @memberof XO.membership.Member
        * @return {Session}
        */
        function latestSession() {
          return this.sessions[0];
        }
        function linked(response, key) {
          return response && response.linked && response.linked[key];
        }
        return Member;
      }();

      /***/
    }
    /******/])
  );
});

;